module.exports = __webpack_public_path__ + "static/img/banner_6.3db2b4bd.png";